export default __webpack_public_path__ + "static/b2-269d47a910caa6e872a56c0360d2bf40.png";